export enum FlowState {
  CREATE = 1,
  PARTIALLYEDITABLE = 2,
  PREVIEW = 3,
}

export default FlowState;
